export default __webpack_public_path__ + "static/media/My-Img-3.b34b7947.jpg";